import { Component, OnInit, Input, OnDestroy, AfterViewInit } from '@angular/core';
import { UtilityService } from 'src/app/services/util/utility.service';
declare var avvpl: any;

@Component({
  selector: 'app-streaming',
  templateUrl: './streaming.component.html',
  styleUrls: ['./streaming.component.less']
})
export class StreamingComponent implements OnDestroy, AfterViewInit {

  @Input() url: string;
  avvplInstance: any;
  isMobileView = false;
  // test = 'https://www.radiantmediaplayer.com/media/bbb-360p.mp4';
  test = 'https://sportradar-lco-ipv4.akamaized.net/26771/659504/mobile/master.m3u8?cid=26771&mid=23185211&ecid=659504&pid=2&dtid=1&sid=377380052208&hdnts=ip=89.216.94.200~exp=1602756966~acl=%2F26771%2F659504%2Fmobile%2F%2A~hmac=6b98942e3d7b127f36bcc31a06f0f5f8eb62ec842df873f666802e44ac4afb9b';

  constructor(private utilityService: UtilityService) {

    // if (!this.url){
    //   this.url = this.test;
    // }
    /* eslint-disable @typescript-eslint/dot-notation */
    // tslint:disable:no-string-literal
    if (!window['avvpl']) {
      const script = document.createElement('script');
      // script.id = 'avvplScript';
      script.type = 'text/javascript';
      script.src = 'https://avplayer-cdn.akamaized.net/dist/latest/avvpl-player.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      // jQuery('head').append(s);

      const style = document.createElement('link');
      // style.id = 'avvplStyle';
      style.rel = 'stylesheet';
      style.type = 'text/css';
      style.href = 'https://avplayer-cdn.akamaized.net/dist/latest/avvpl-player.css';
      document.getElementsByTagName('head')[0].appendChild(style);

      this.isMobileView = utilityService.mobileView;


    }
  }


  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngAfterViewInit() {
    const interval = setInterval(() => { this.play(interval); }, 100);
  }

  play(interval: any) {
    const config = {
      id: 'playercontainer',
      allowFullScreen: false
    };

    if (window['avvpl']) {
      this.avvplInstance = new avvpl.setupPlayer(config);

      clearInterval(interval);
    }
  }

  ngOnDestroy() {
    this.avvplInstance.removeVideoContainer();
  }


}
